import { lt } from '@mews/framework';
import { SelectField } from '@mews-commander/form';
import { TextKey } from '@mews-commander/enums';
import { ExportFormat } from '@mews-commander/data-access';
import { useGetSelectOptions } from '../../../common/hooks';

const mapFormatTypes: Record<ExportFormat, Mews.TextKey> = {
    [ExportFormat.Excel]: TextKey.CityLedgerExportToExcel,
    [ExportFormat.Csv]: TextKey.CityLedgerExportToCsv,
    [ExportFormat.Json]: TextKey.CityLedgerExportToJson,
};

export const FormatFilter = ({ name }: { name: string }) => {
    const formatOptions = useGetSelectOptions(mapFormatTypes) ?? [];
    return (
        <SelectField
            data-test-id="format-filter"
            name={name}
            options={formatOptions}
            label={lt('Format')}
            showEmptyValue={false}
            virtualized
        />
    );
};
